


































import { createComponent, computed, ref } from "@vue/composition-api";
import { BaseCheckbox, BaseMoreInfo } from "@web-components";
//eslint-disable-next-line
import { Activity } from "../types/activity";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

interface ActionPlanActivityCardProps {
  activity: Activity;
  value: boolean;
}

export default createComponent({
  components: {
    BaseCheckbox,
    BaseMoreInfo
  },
  props: {
    activity: {
      type: Object as () => Activity
    },
    value: {
      type: Boolean,
      required: true
    },
    editMode: {
      type: Boolean,
      default: true
    }
  },
  setup(props: Readonly<ActionPlanActivityCardProps>) {
    const dictionary = useDictionary();

    const label = computed(() =>
      props.value
        ? dictionary.dictionary.DCC_PersonalPlan_Added
        : dictionary.dictionary.DCC_PersonalPlan_Add
    );

    const showMore = ref(false);

    return {
      label,
      showMore,
      ...dictionary
    };
  }
});
